import React from 'react';
import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { isDataLoaded } from '../../types';
import { DeleteModal } from '../CommonDeleteModals/DeleteModal';



export const DeleteGatewayModal: React.FC<{
    open: boolean;
    onClose: Function;
    handleContinue: Function;
    name: string;
}> = (props) => {

    const { onClose, open,handleContinue,name } = props;
    const deviceDetails = useDeviceDetails();

    return (
            <DeleteModal
                open={open}
                onClose={onClose}
                handleContinue={handleContinue}
                data={  isDataLoaded(deviceDetails) ? deviceDetails.value.devices : []}
                name={name}
            /> 
    
    );
};
